import { render, staticRenderFns } from "./ClaimDateQuestion.vue?vue&type=template&id=84ed5902&scoped=true"
import script from "./ClaimDateQuestion.vue?vue&type=script&lang=ts"
export * from "./ClaimDateQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ClaimDateQuestion.vue?vue&type=style&index=0&id=84ed5902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ed5902",
  null
  
)

export default component.exports